import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { listPrices } from "../../../api/payment";

export const fetchPrices = createAsyncThunk(
  "fetchPrices",
  async () => {
    const res = await listPrices();
    return res;
  }
);

const initialState = {
  isLoading: false,
  value: [],
  error: null,
};

const priceSlice = createSlice({
  name: "price",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPrices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.value = action.payload;
      })
      .addCase(fetchPrices.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { reset } = priceSlice.actions;
export { priceSlice };
